define('plugin/invoice/InvoicePlugin',['require','lib/plugin/PluginAbstract','plugin/invoice/controller/InvoiceController','plugin/invoice/controller/InvoiceRecurringProfileController','plugin/invoice/controller/InvoicePaymentMethodController','plugin/invoice/step/InvoiceStep','plugin/invoice/view/InvoiceNotificationLayout','plugin/paid-events/collection/PaymentSystemCollection','plugin/invoice/collection/InvoicePaymentMethodCollection','plugin/invoice/collection/UnpaidInvoicesCollection','handlebars','lib/AppRouter'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var InvoiceController = require('plugin/invoice/controller/InvoiceController');
    var InvoiceRecurringProfileController = require('plugin/invoice/controller/InvoiceRecurringProfileController');
    var InvoicePaymentMethodController = require('plugin/invoice/controller/InvoicePaymentMethodController');
    var InvoiceStep = require('plugin/invoice/step/InvoiceStep');
    var InvoiceNotificationLayout = require('plugin/invoice/view/InvoiceNotificationLayout');

    var PaymentSystemCollection = require('plugin/paid-events/collection/PaymentSystemCollection');
    var InvoicePaymentMethodCollection = require('plugin/invoice/collection/InvoicePaymentMethodCollection');
    var UnpaidInvoicesCollection = require('plugin/invoice/collection/UnpaidInvoicesCollection');

    var Handlebars = require('handlebars');
    var AppRouter = require('lib/AppRouter');

    return PluginAbstract.extend({

        _unpaidInvoicesCollection: null,
        _paymentSystemCollection: null,
        _controller: null,
        _recurringProfileController: null,
        _paymentMethodController: null,
        _requestModel: null,
        _step: null,
        _invoiceModulesRegions: {
            'invoiceNotification': '#sb_invoice_notification_container',
        },
        _lastFinishedPaymentId: null,

        initialize: function () {
            this._paymentSystemCollection = new PaymentSystemCollection();
            this._unpaidInvoicesCollection = new UnpaidInvoicesCollection();
            this._paymentMethodCollection = new InvoicePaymentMethodCollection();
            this._clientModel = this.getOption('clientModel');

            this._controller = new InvoiceController({
                'paymentSystemCollection': this._paymentSystemCollection,
                'paymentMethodCollection': this._paymentMethodCollection,
                'clientModel': this._clientModel,
                'app': this.getOption('app')
            });
            this._recurringProfileController = new InvoiceRecurringProfileController({
                'app': this.getOption('app')
            });
            this._paymentMethodController = new InvoicePaymentMethodController({
                'app': this.getOption('app')
            });

            var invoiceRouter = new AppRouter({
                appRoutes: {
                    'invoice/list(/page/:page)(/)': 'list',
                    'invoice/view/:id(/)': 'view',
                    'invoice/pay/:id(/return/:return)(/direct-link/:direct)(/)': 'pay',
                },
                menuItem: 'invoice',
                controller: this._controller
            });

            var invoiceRecurringProfileRouter = new AppRouter({
                appRoutes: {
                    'invoice-recurring-profile/list(/page/:page)(/)': 'list',
                    'invoice-recurring-profile/view/:id(/)': 'view',
                    'invoice-recurring-profile/view/:id/page/:page(/)': 'view'
                },
                menuItem: 'recurring-profile',
                controller: this._recurringProfileController
            });

            var invoicePaymentMethodRouter = new AppRouter({
                appRoutes: {
                    'invoice-payment-method/list(/)': 'list'
                },
                menuItem: 'payment-method',
                controller: this._paymentMethodController
            });

            PluginAbstract.prototype.initialize.apply(this);

            // just to let process onFinishPayment event
            var instance = this;
            setTimeout(function () {
                instance._unpaidInvoicesCollection.load();
            }, 1000);

            this.initTemplateHelpers();
        },

        initModules: function (layout) {
            _.each(this._invoiceModulesRegions, function (selector, region) {
                layout.addRegion(region, selector);
            });

            if (!this.notification) {
                this.notification = new InvoiceNotificationLayout({
                    'collection': this._unpaidInvoicesCollection
                });

                layout.invoiceNotification.show(this.notification);

                var instance = this;
                Backbone.Wreqr.radio.channel('navigation').vent.on(
                    'navigate:to', function (params) {
                        if (params.name !== 'pay') {
                            if (layout.invoiceNotification && layout.invoiceNotification.$el) {
                                layout.invoiceNotification.$el.removeClass('hidden');
                            }
                        } else {
                            if (!params.args[1]) {
                                instance._unpaidInvoicesCollection.reload();
                            }
                            if (layout.invoiceNotification && layout.invoiceNotification.$el) {
                                layout.invoiceNotification.$el.addClass('hidden');
                            }
                        }
                    }
                );

                Backbone.Wreqr.radio.channel('client_login').vent.on(
                    'client:signin', function (params) {
                        instance._unpaidInvoicesCollection.reload();
                    }
                );
                Backbone.Wreqr.radio.channel('client_login').vent.on(
                    'client:signout', function (params) {
                        instance._unpaidInvoicesCollection.reload();
                    }
                );
            }
        },

        onFinishPayment: function (view, data) {
            if (this._lastFinishedPaymentId !== data.id) {
                this._unpaidInvoicesCollection.reload();
                this._lastFinishedPaymentId = data.id;
            }
        },

        initTemplateHelpers: function () {
            // invoices partials
            Handlebars.registerPartial('invoiceListPart', jQuery('#invoice_list_part').html());
            Handlebars.registerPartial('invoiceTabsPart', jQuery('#invoice_tabs_part').html());
        },

        /**
         * On save booking information
         *
         * @param requestModel
         */
        finishBooking: function (requestModel) {
            // this._step.setBookingRequestModel(requestModel);

            //NB if this._step has been initialized, it will be just returned as in commented line above. But if it isn't, we avoid "calling setBookingRequestModel of null" error
            this.getStep('invoice', {/*TODO params*/}).setBookingRequestModel(requestModel);
        },

        /**
         * Adds location step
         *
         * @param Array steps
         * @return Array|null
         */
        modifySteps: function (steps) {
            steps.push('invoice');
            return steps;
        },

        /**
         * Returns plugin step object
         *
         * @see lib/controller/booking/BaseStep
         * @param String step - step name
         * @param Object params - step parameters
         * @return BaseStep|null
         */
        getStep: function (step, params) {
            if (step === 'invoice') {
                if (!this._step) {
                    this._step = new InvoiceStep(_.extend({
                        requestModel: this._requestModel
                    }, params));
                }

                return this._step;
            }
        }

    });

});
